import React from 'react'
import './style.scss'
import bem from '../../helpers/bem'
import CircularProgressBar from '../circularProgressBar'
import Card from '../card'
import {PLAYER} from '../../constants/board'
import {REG_CARD} from '../../constants/regexp'
import {
  PLAYER_TIE_TITLE,
  PLAYER_WIN_TITLE, PLAYER_WINHI_TITLE, PLAYER_WINLO_TITLE,
} from '../../constants/translations'
import {getCardKey} from '../../helpers/card'
import {TYPE_PLAYER} from '../../constants/types';

const Player = ({
                  player,
                  removeCard,
                  activeField,
                  setActiveField,
                  setChosenCard,
                  isNotWinnerPlayer,
                  isPOC,
                  isWinnerCard,
                  isResult,
                  setCardsMenu,
                  slider,
                  splitPotWinner,
                  noCommunityCards,
                  hiLo,
                  oddsWinner,
                }) => {
  const block = 'player';
  const playerProgressActive = !!activeField && !isNotWinnerPlayer;
  const isActiveFieldPlayer = activeField && activeField.type === TYPE_PLAYER;
  const isShirtChosen = index => isActiveFieldPlayer && (activeField && activeField.card.id) === index;

  const isCardChosen = (index, card) => {
    return splitPotWinner
      || isWinnerCard(card)
      || (isActiveFieldPlayer && (activeField && activeField.card.id) === index);
  };

  const getPlayerProgressPercent = () => {
    if (isPOC) {
      const winPercent = parseFloat(player.win);
      return hiLo
        ? (winPercent + parseFloat(player.winLo)) / 2
        : winPercent || 0
    }
    return false;
  };

  const handleClickPlayer = (e) => {
    setActiveField(
      PLAYER,
      player.id,
      e.target.className && e.target.className.match(REG_CARD)
    );
    if (setCardsMenu) {
      setCardsMenu(true)
    }
  };

  return isResult ? (
    <div
      className={bem({
        block,
        mods: {
          'is-result': isResult,
        }
      })}
    >
      <div className={bem({block, elem: 'mount'})}>
        <div className={bem({block, elem: 'mount-player'})}>
          <div className={bem({block, elem: 'mount-name'})}>
            {player.playerName}
          </div>
          <div className={bem({block, elem: 'mount-avatar'})}>
            <CircularProgressBar
              active={playerProgressActive}
              percent={getPlayerProgressPercent()}
            >
              <div className="buddy"/>
            </CircularProgressBar>
          </div>
        </div>
        <div className={bem({block, elem: 'mount-deck', mods: {['cards-count-' + player.hand.length]: true}})}>
          {player.hand.map((card, index) => {
            if (card) {
              return <Card
                rank={card.rank}
                suit={card.suit}
                key={getCardKey(index, card)}
                isResult
              />
            }
            return <Card
              key={getCardKey(index)}
              playerId={player.id}
              handId={index}
              chosen={isShirtChosen(index)}
              setChosenCard={setChosenCard}
              isResult
              player
            />
          })}
        </div>
        {isPOC && (
          <div>
            <div className={bem({block, elem: 'mount-win'})}>
              {PLAYER_WIN_TITLE} <span className={bem({block, elem: 'mount-win-percent'})}>{player.win || '0%'}</span>
            </div>
            <div className={bem({block, elem: 'mount-tie'})}>
              {PLAYER_TIE_TITLE} <span className={bem({block, elem: 'mount-tie-percent'})}>{player.tie || '0%'}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div
      className={bem({
        block, mods: {
          'active': !!activeField,
          'no-community-cards': !!noCommunityCards,
          'is-poc': !!isPOC,
          'is-result': !!isResult,
          'slider': !!slider,
        }
      })}
      onClick={(e) => handleClickPlayer(e)}
    >
      <div className={bem({block, elem: 'mount'})}>
        <div className={bem({block, elem: 'mount-name'})}>
          {player.playerName}
        </div>
        {isPOC && (
          <React.Fragment>
            <div className={bem({block, elem: 'mount-win'})}>
              {hiLo ? PLAYER_WINHI_TITLE : PLAYER_WIN_TITLE} <span
              className={bem({block, elem: 'mount-win-percent'})}>{player.win || '0%'}</span>
            </div>
            {hiLo && (
              <div className={bem({block, elem: 'mount-winlo'})}>
                {PLAYER_WINLO_TITLE} <span
                className={bem({block, elem: 'mount-winlo-percent'})}>{player.winLo || '0%'}</span>
              </div>
            )}
            {!hiLo && (
              <div className={bem({block, elem: 'mount-tie'})}>
                {PLAYER_TIE_TITLE} <span
                className={bem({block, elem: 'mount-tie-percent'})}>{player.tie || '0%'}</span>
              </div>
            )}
          </React.Fragment>
        )}
        <div className={bem({block, elem: 'mount-avatar'})}>
          <CircularProgressBar
            active={playerProgressActive}
            percent={getPlayerProgressPercent()}
          >
            <div className="buddy"/>
          </CircularProgressBar>
        </div>
        <div className={bem({
          block,
          elem: 'mount-deck',
          mods: {['cards-count-' + player.hand.length]: true}
        })}>
          {player.hand.map((card, index) => {
            if (card) {
              return <Card
                rank={card.rank}
                suit={card.suit}
                removeCard={removeCard}
                key={getCardKey(index, card)}
                playerId={player.id}
                handId={index}
                chosen={isCardChosen(index, card)}
                setChosenCard={setChosenCard}
                player
              />
            }
            return <Card
              key={getCardKey(index)}
              playerId={player.id}
              handId={index}
              chosen={isShirtChosen(index)}
              setChosenCard={setChosenCard}
              player
            />
          })}
        </div>
      </div>
    </div>
  )
};

export default Player;